<div class="poll-title">
    {{data.title}}
</div> 


<div class="word-cloud">
    <angular-tag-cloud *ngIf="wcData"
      [data]="wcData"
      [config]="options">
    </angular-tag-cloud>
</div>